import { DamageC2CodeResponse } from "../../api-models/response/DamageMainCodeResponse";

export class DamageC2Code implements DamageC2CodeResponse {
  code: string;
  text: string;

  constructor(damageC2Code: DamageC2CodeResponse, public isValid: boolean) {
    this.code = damageC2Code.code;
    this.text = damageC2Code.text;
  }

  setText(newText: string) {
    this.text = newText;
  }

  public get label() {
    return `${this.code} ${this.text}`;
  }
}

export const emptyC2Code = new DamageC2Code(
  {
    code: "",
    text: "",
  },
  false
);
